<template>
  <div>
    <section class="flex flex-wrap items-stretch">
      <CommunicationsList
        :page="page"
        :status="status"
        :types="types"
        :category-slug="categorySlug"
        @loaded="(loaded) => { communicationsLoaded = loaded }"
      />
    </section>
  </div>
</template>

<script type="text/babel">
import CommunicationsList from 'Communication/Resources/assets/js/components/CommunicationsList'

export default {
  name: 'CommunicationCategoryDetails',
  components: {
    CommunicationsList,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    page: {
      type: [String, Number],
      required: false,
      default: 1,
    },
    preExistingTypes: {
      type: String,
      required: false,
      default: 'blog-entries',
    },
    categorySlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      types: ['blog-entries'],
      communicationsLoaded: false,
    }
  },
}
</script>
